import { styled } from '@linaria/react';

import { uiToken } from '../../constants/uiToken';
import { Typography } from '../Typography/Typography';

export type DividerType = 'default' | 'liquid';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &::after,
  &::before {
    display: block;
    height: 1px;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    content: '';
    flex: 1;
  }

  &::after {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

export const Label = styled(Typography.H5)`
  flex-shrink: 0;
  margin: 0 8px;
  color: ${uiToken.color.text.secondary};
`;
